// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"396":"2c14fb84","982":"1286dc73"}[chunkId] + ".chunk.css";
};